import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Enums } from '../../../../../configs/Enums';
import { AppSettingsService } from '../../../app-settings.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-settings',
  templateUrl: './tickets-settings.component.html',
  styleUrls: ['./tickets-settings.component.scss'],
  standalone: false,
})
export class TicketsSettingsComponent implements OnInit {
  public moment = require('moment');
  public timeMounterAssignTickets = { hour: 0, minute: 0 };
  public timeNextDayToAssignTickets = { hour: 0, minute: 0 };
  public countDaysToAssigment = null;
  public communicatorOpenCrashLimit = null;
  public loading = false;
  public ticketsSettingsError: null | string;
  public ticketsSettingsSuccess: null | string;

  @Input() settings: any;

  constructor(private appSettingsService: AppSettingsService) {}

  ngOnInit() {
    this.makeTicketsSettings();
  }

  private makeTicketsSettings() {
    const ticketSettings = this.settings;
    const timeMounterAssignTickets = this.timeMounterAssignTickets;
    const timeNextDayToAssignTickets = this.timeNextDayToAssignTickets;
    const mounterDate = this.moment(ticketSettings.self_assignment_time);
    const ticketsAssigned = this.moment(ticketSettings.tomorrow_assignment_time);

    timeMounterAssignTickets.hour = mounterDate.hours();
    timeMounterAssignTickets.minute = mounterDate.minute();
    timeNextDayToAssignTickets.hour = ticketsAssigned.hours();
    timeNextDayToAssignTickets.minute = ticketsAssigned.minute();
    this.countDaysToAssigment = ticketSettings.days_for_assignment;
    this.communicatorOpenCrashLimit = ticketSettings.communicator_open_crash_limit;
  }

  onChangeTimeMounterAssignTickets(time) {
    this.timeMounterAssignTickets = time;
  }

  onChangeTimeNextDayToAssignTickets(time) {
    this.timeNextDayToAssignTickets = time;
  }

  checkValidTicketsSettingsForm() {
    const timeMounterAssignTickets = this.timeMounterAssignTickets;
    const timeNextDayToAssignTickets = this.timeNextDayToAssignTickets;

    return (
      this.countDaysToAssigment &&
      timeMounterAssignTickets &&
      timeNextDayToAssignTickets &&
      !isNaN(timeMounterAssignTickets.hour) &&
      !isNaN(timeMounterAssignTickets.minute) &&
      !isNaN(timeNextDayToAssignTickets.hour) &&
      !isNaN(timeNextDayToAssignTickets.minute)
    );
  }

  onSaveTicketsSettings() {
    const timeMounterAssignTickets = this.timeMounterAssignTickets;
    const timeNextDayToAssignTickets = this.timeNextDayToAssignTickets;
    const requestObj = {
      days_for_assignment: this.countDaysToAssigment,
      tomorrow_assignment_time: this.moment().hours(timeNextDayToAssignTickets.hour).minutes(timeNextDayToAssignTickets.minute).format('YYYY-MM-DDTHH:mm'),
      self_assignment_time: this.moment().hours(timeMounterAssignTickets.hour).minutes(timeMounterAssignTickets.minute).format('YYYY-MM-DDTHH:mm'),
      communicator_open_crash_limit: this.communicatorOpenCrashLimit,
    };

    this.ticketsSettingsError = null;
    this.ticketsSettingsSuccess = null;

    this.loading = true;
    this.appSettingsService.updateSettings(requestObj).subscribe(
      (response) => {
        this.ticketsSettingsSuccess = 'Настройки успешно сохранены.';
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.ticketsSettingsError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
      }
    );
  }
}
